import type { QuickReplyChatType } from '../../../services/conversationQuickReplies';

export const THREAD_OPTIONS: readonly { value: QuickReplyChatType; label: string }[] = [
    { value: 'external', label: 'Practice' },
    { value: 'internal', label: 'Internal' }
];

// Blue for practice-facing, the internal thread's teal for ODO-only.
export const THREAD_PILL_TONE: Readonly<Record<QuickReplyChatType, string>> = {
    external: 'text-white bg-blue-600',
    internal: 'text-white bg-[#007E87]'
};

export function threadLabel(chatType: QuickReplyChatType): string {
    return THREAD_OPTIONS.find((option) => option.value === chatType)?.label ?? chatType;
}
